import mod from "-!./EmployeeNew.js?vue&type=script&lang=js&"; export default mod; export * from "-!./EmployeeNew.js?vue&type=script&lang=js&"